import * as React from "react";
import { Helmet } from "react-helmet";
import { StaticImage } from "gatsby-plugin-image";
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../styles/custom.css";


// gsap plugin for scroll trigger.
gsap.registerPlugin(ScrollTrigger);

const IndexPage = () => {
  useEffect(() => {
    // Write your GSAP here
    gsap.fromTo(".myself", { y: 20 }, { y: 0, start: "top center", duration: "1", opacity: "1", delay: "0.3" });
    gsap.fromTo(".makeSomething", { y: 20 }, { y: 0, start: "top center", duration: "1", opacity: "1", delay: "0.6" });
    gsap.fromTo(".Product_tings", { y: 20 }, { y: 0, start: "top center", duration: "1", opacity: "1", delay: "0.9" });

  });

  return (
    <>
      <Helmet>
        <title>Nikhil || Product</title>
      </Helmet>

      <body>
        <div className="container-fluid px-0">
          <section id="sec1" className="px-3">
            <div className="row">
              <div className="col-12 col-lg-11 d-lg-block px-lg-5">
                <h1 className="nik92Head my-5">{"< nik92 />"}</h1>
                <div className="desktop-text my-5">
                  <h2 className="myself">
                    Hi <span className="colorG">I'm Nikhil</span> a.k.a{" "}
                    <span className="colorG">nik92</span>
                  </h2>
                  <h3 className="makeSomething d-block">
                    I Strive to Make something <br /> people want
                  </h3>
                  <h2 className="Product_tings d-block">
                    as a{" "}
                    <span className="colorG">
                      Product Builder
                    </span>
                  </h2>
                </div>
              </div>
              <div className="col-12 col-lg-1 d-lg-block">
                <div className="MainIcons d-flex flex-column">
                  <div className="main-content">
                    <a rel="noreferrer" target="_blank" href="mailto:nikhilweb19@gmail.com">
                      <i className="head-icons bi bi-envelope-fill"></i>
                    </a>
                    <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/nikhilarora92/">
                      <i className="head-icons bi bi-linkedin"></i>
                    </a>
                    <a rel="noreferrer" target="_blank" href="https://medium.com/@nik92">
                      <img className="medium1" src="assets/medium.svg" alt="" />
                    </a>
                    {/* <a rel="noreferrer" target="_blank" href="https://drive.google.com/file/d/1ws2VcNseADz8D-KBc2ydxfCC9BSVf1xy/view?usp=sharingss">
                      <i className="head-icons bi bi-file-earmark-arrow-down-fill"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <section id="sec2" className="d-lg-block px-lg-5">
          <div className="container">
            <div className="about_underlay">
              <h1>
                <div className="line animate_line" style={{ opacity: "1" }}>
                  <span>ABOUT</span>
                </div>
                <div className="line animate_line" style={{ opacity: "1" }}>
                  <span>ME</span>
                </div>
              </h1>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6">
                <h4 className="About">About me</h4>
                <p className="MainPara">
                  Hi there, I'm Nikhil, a Product Developer, always chasing new
                  ideas and Problem statements. I have had experience developing
                  products in the Freelance/gig industry, Insurance/Insurtech, and
                  Finance/Fintech.
                  <br />
                  <br /> Currently, I'm exploring the world of blockchain and
                  Decentralized applications development.
                  <br />
                  <br /> Always up for a conversation on discord, username
                  Nik92#4116
                </p>
              </div>
              <div className="col-12 col-lg-6 shipping">
                <img
                  className="ship_prod"
                  src="/assets/ship_prod.gif"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>
        <section id="sec3">
          <h2 className="text-center">BUIDL Projects</h2>
          <div className="container" >
            <div className="white-frame">
              <div className="medster">
                <div className="row">
                  <div className="col-md-6 col-12 order-md-0 order-1">
                    <img src="/assets/Medster.png" alt="" />
                  </div>
                  <div className="col-md-6 col-12 order order-md-1 order-0">
                    <h4><span className="s1">INSURANCE</span> MADE EASIER</h4>
                    <a href="https://medster.netlify.app/">
                      <h3>MEDSTER</h3>
                    </a>
                    <p>Medster was a take on, defining a new set of workings for OPD insurance for the masses. <br /> <br />
                      OPD was introduced in 2017, and to date is riddled with problems and terrible UX. <br />
                      Medster used technology and synchronization b/w three parties in the transaction, i.e Consumer, Doctor, Insurer to ensure a smooth end-to-end UX.</p>
                  </div>
                </div>
              </div>
              <div className="investopay my-4">
                <div className="row">
                  <div className="col-md-6 col-12">
                    <h4 className="text-center">PAY{">"}SAVE{">"}INVEST</h4>
                    <a href="https://investopay-app.herokuapp.com/">
                      <h3 className="text-center">investoPay</h3>
                    </a>
                    <p>investoPay is a similar take on investing your small leftovers to introduce a habit of investing.
                      <br /> <br />
                      The way we differed was our UX. investoPay works on the user opening the app often.
                      Hence the concept of both Payments through the app and learnings on the go was introduced.
                      <br />
                      The premise of the idea was, we wanted to make our users~ active investors</p>
                  </div>
                  <div className="col-md-6 col-12">
                    <img src="/assets/investopay.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="nft">
                <div className="row">
                  <div className="col-md-6 col-12 order-md-0 order-1">
                    <div className="mint-img ">
                      <img src="assets/Mint.png" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 order-md-1 order-0">
                    <div>
                    <a href= "https://testnets.opensea.io/assets/0x8acb7ca932892eb83e4411b59309d44dddbc4cdf/0" target="_blank"><h3 className="text-center">NFT Minter</h3></a>
                      <p>NFT minter is on chain minter of differents objects containing different attributed in form of metadata.
                        <br /> <br />
                        The implementation includes chainlink oracle for hosting contracts and rinkby test network. All the characters could be seen on test.opensea.
                        </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dex my-5">
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div>
                      <a href="https://github.com/nik92eth/Decentralized-Regional-Order-Manager">
                        <h3>Regional order Dapp</h3>
                      </a>
                      <p>Regional Dapp was made as my introduction to the world of web3. <br /> <br />
                        The premise of the idea was, during the pandemic due to a shortage of goods and medications, many wholesale merchants listed different prices to different individuals based on affordability and severity.

                        In a decentralized environment, individuals can place orders anonymously, and fulfillment would be done by verifiers of the transactions.</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="dex-img">
                      <img src="assets/dex.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h2 className="text-center">DECKS</h2>
            <div className="whiteframe-2">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 col-12">
                  <iframe src="https://slides.com/helloworld-9/deck-7b11b9/embed?style=light" width="576" height="420" scrolling="no" frameBorder="0" webkitallowfullscreen='true' mozallowfullscreen='true' allowFullScreen></iframe>
                  </div>
                  <div className="col-md-6 col-12">
                  <iframe src="https://slides.com/helloworld-9/deck/embed?style=light" width="576" height="420" scrolling="no" frameBorder="0" webkitallowfullscreen='true' mozallowfullscreen='true' allowFullScreen></iframe>
                  </div>                 
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                  <iframe src="https://slides.com/helloworld-9/deck-7b368b/embed?style=light" width="576" height="420" scrolling="no" frameBorder="0" webkitallowfullscreen='true' mozallowfullscreen='true' allowFullScreen></iframe>
                  </div>
                  <div className="col-md-6 col-12">
                  <iframe src="https://slides.com/helloworld-9/deck-4970d2/embed?style=light" width="576" height="420" scrolling="no" frameBorder="0" webkitallowfullscreen='true' mozallowfullscreen='true' allowFullScreen></iframe>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

        </section>
        <section id="sec4">
          <div className="container">
            <div className="row">
              <div className="mySkill">
                <h2>My Skills</h2>
              </div>
              <div className="skills_underlay">
                <h1>
                  <div className="line animate_line" style={{ opacity: "1" }}>
                    <span>MY</span>
                  </div>
                  <div className="line animate_line" style={{ opacity: "1" }}>
                    <span>SKILLS</span>
                  </div>
                </h1>
              </div>
              <div className="skill-content">
                <div className="skillC01">
                  <h3 className="text-center">Code SKills</h3>
                  <div className="skills-grid">
                    <div className="skills_skill c">
                      <img src="assets/6C.svg" alt="" />
                      <p>C</p>
                    </div>
                    <div className="skills_skill cpp">
                      <img src="assets/5C++.svg" alt="" />
                      <p>C++</p>
                    </div>
                    <div className="skills_skill sol">
                      <img src="assets/Solidity_logo.svg"
                        alt=""
                      />
                      <p>solidity</p>
                    </div>
                    <div className="skills_skill htcss">
                      <img src="assets/html+css.svg" alt="" />
                      <p>HTML{"&"}CSS</p>
                    </div>
                    <div className="skills_skill js">
                      <img src="assets/3Javascript.svg" alt="" />
                      <p>Javascript</p>
                    </div>
                    <div className="skills_skill node">
                      <img src="assets/4NodeJS.svg" alt="" />
                      <p>NodeJS</p>
                    </div>
                    <div className="skills_skill python">
                      <img src="assets/4Python.svg " alt="" />
                      <p>Python</p>
                    </div>
                    <div className="skills_skill sql">
                      <img src="assets/sql-server.svg" alt="" />
                      <p>SQL</p>
                    </div>
                    <div className="skills_skill vba">
                      <img src="assets/VBA-Logo.png" alt="" />
                      <p>VBA</p>
                    </div>
                  </div>
                </div>
                <div className="skillC02">
                  <h3>Design</h3>
                  <div className="skills-content-1">
                    <div className="skills_skill figma">
                      <img src="assets/Figma.svg" alt="" />
                      <p>Figma</p>
                    </div>
                    <div className="skills_skill xd">
                      <img src="assets/Adobe XD.svg" alt="" />
                      <p>Adobe XD</p>
                    </div>
                    <div className="skills_skill sketch">
                      <img src="assets/sketch.svg" alt="" />
                      <p>Sketch</p>
                    </div>
                  </div>
                </div>
                <div className="skillC02">
                  <h3>On the Job</h3>
                  <div className="skills-content-1">
                    <div className="skills_skill medium">
                      <a href="https://medium.com/@nik92">
                        <img src="assets/medium-new.svg" alt="" />
                      </a>
                      <p>Medium</p>
                    </div>
                    <div className="skills_skill wp">
                      <img src="assets/6Wordpress.svg" alt="" />
                      <p>WordPress</p>
                    </div>
                    <div className="skills_skill pm">
                      <div className="pm-desk">
                        <b>
                          <p>Product Management</p>
                        </b>
                      </div>
                      <div className="pm-phone">
                        <img src="assets/pm.svg" alt="" />
                        <p>Product Management</p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="sec5">
          <div className="container">
            <div className="row">
              <div className="mainHead">
                <h3 className="text-center">Get in touch</h3>
                <h4 className="text-center">Let's make something happen</h4>
                <div className="footer-content">
                  <div className="footer-links">
                    <a href="mailto:nikhilweb19@gmail.com">
                      <i className="footicons bi bi-envelope-fill"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/nikhilarora92/">
                      <i className="footicons bi bi-linkedin"></i>
                    </a>
                    <a href="https://twitter.com/_nik92">
                      <i className="footicons bi bi-twitter"></i>
                    </a>
                    <a target="_blank" href="Nik92#4116">
                      <i className="footicons bi bi-discord"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
    </>
  );
};
export default IndexPage;
